import config from '../../config';

const { google: { mapOptions, GOOGLE_MAP_ID } } = config;

export default (zoom = mapOptions.zoom, lat = mapOptions.center.lat, lng = mapOptions.center.lng, satellite) => ({
  center: { lat: Number(lat), lng: Number(lng) },
  zoom: Number(zoom),
  disableDefaultUI: true,
  mapTypeId: satellite ? window.google.maps.MapTypeId.SATELLITE : window.google.maps.MapTypeId.ROADMAP,
  mapTypeControl: true,
  streetViewControl: true,
  scaleControl: true,
  gestureHandling: 'greedy',
  minZoom: 8,
  clickableIcons: false,
  mapId: GOOGLE_MAP_ID,
});
